module.exports = __webpack_public_path__ + "static/media/IMG-20.60f91a45.jpg";